import { SET_SHOW_SELECT_PROJECTS } from './types';

export function setShowSelectProjects(value: boolean) {
  return {
    type: SET_SHOW_SELECT_PROJECTS,
    payload: value,
  };
}
